import {
    GET_ACCOUNT_TYPE_ADMIN_SUCCESS,
    GET_ACCOUNT_TYPE_ADMIN_FAILED,
    LOADING_GET_ACCOUNT_TYPE_ADMIN,
    RESET_GET_ACCOUNT_TYPE_ADMIN,
    NETWORK_ERROR_GET_ACCOUNT_TYPE_ADMIN
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GET_ACCOUNT_TYPE_ADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GET_ACCOUNT_TYPE_ADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GET_ACCOUNT_TYPE_ADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GET_ACCOUNT_TYPE_ADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GET_ACCOUNT_TYPE_ADMIN:
            return (state = initialState);
        default:
            return state;
    }
};